import type { FC, ReactNode } from 'react'

import { cn } from '@/lib/utils'

interface SectionHeadingProps {
    id?: string
    eyebrow: string
    title: ReactNode
    description?: ReactNode
    align?: 'left' | 'center'
    tone?: 'light' | 'dark'
    className?: string
}

const SectionHeading: FC<SectionHeadingProps> = ({
    id,
    eyebrow,
    title,
    description,
    align = 'left',
    tone = 'light',
    className
}): ReactNode => {
    const isDark = tone === 'dark'

    return (
        <div className={cn('max-w-2xl', align === 'center' && 'mx-auto text-center', className)}>
            <p className={cn('inline-flex items-center gap-2 text-sm font-semibold tracking-wide', isDark ? 'text-brand-teal-bright' : 'text-brand-teal-ink')}>
                <span aria-hidden='true' className='size-1.5 rounded-full bg-brand-orange' />
                {eyebrow}
            </p>

            <h2
                id={id}
                className={cn(
                    'mt-4 text-3xl font-semibold leading-tight tracking-tight sm:text-4xl lg:text-[2.75rem] lg:leading-[1.12]',
                    isDark ? 'text-white' : 'text-foreground'
                )}
            >
                {title}
            </h2>

            {description && (
                <p className={cn('mt-5 text-base leading-relaxed sm:text-lg', isDark ? 'text-white/75' : 'text-muted-foreground')}>
                    {description}
                </p>
            )}
        </div>
    )
}

export default SectionHeading
